import { ContactUsVariant } from "@/utils/contactUs";
import { createContext } from "react";

export const initialContactUsContext = {
    contactUsVariant: null as ContactUsVariant,
};

export const ContactUsContext = createContext(initialContactUsContext);
